var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import './EstablishmentsControlPage.scss';
import InputSearch from '@/components/InputSearch/InputSearch';
import AddIcon from '@assets/svg/addIcon.svg';
import { useAppSelector, useDebounce } from '@/hooks/redux';
import { useDeleteRestaurantsMutation, useGetRestaurantsWithSearchQuery } from '@/services/restaurantsApi';
import RestaurantItem from './RestaurantItem/restaurantItem';
import { useNavigate } from 'react-router-dom';
import Loader from '@/components/Loader/Loader';
import { useGetUserByIdQuery } from '@/services/usersApi';
import { useGetCitiesQuery } from '@/services/citiesApi';
import { getEstablishmentQueryScope } from '@/utils/managedRestaurants';
import { Select } from 'antd';
var Option = Select.Option;
var restaurantTypes = ['Караоке/клубы', 'Кафе/бары/рестораны', 'Lounge', 'Фитнес/спорт/активный отдых', 'Кофейни', 'Другое'];
var EstablishmentsControlPage = function () {
    var _a, _b, _c;
    var _d = useState(''), search = _d[0], setSearch = _d[1];
    var _e = useState(''), selectedType = _e[0], setSelectedType = _e[1]; // для типа ресторана
    var _f = useState(1), currentPage = _f[0], setCurrentPage = _f[1];
    var itemsPerPage = 10;
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var currentUserRole = user === null || user === void 0 ? void 0 : user.role;
    var _g = useState(''), selectedCity = _g[0], setSelectedCity = _g[1];
    var _h = useGetUserByIdQuery({ id: user === null || user === void 0 ? void 0 : user.id }, { skip: !(user === null || user === void 0 ? void 0 : user.id), refetchOnMountOrArgChange: true }), userData = _h.data, isUserDataSuccess = _h.isSuccess;
    var restId = ((_a = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _a === void 0 ? void 0 : _a.id) || 0;
    var establishmentScope = getEstablishmentQueryScope(user === null || user === void 0 ? void 0 : user.role, userData);
    var cities = useGetCitiesQuery().data;
    var isSuperAdmin = (user === null || user === void 0 ? void 0 : user.role) === 'системный администратор';
    var isManager = (user === null || user === void 0 ? void 0 : user.role) === 'системный менеджер';
    var isEmployee = (user === null || user === void 0 ? void 0 : user.role) === 'сотрудник';
    console.log(userData, 'datadatadatadatadatadata');
    useEffect(function () {
        if (userData === null || userData === void 0 ? void 0 : userData.city) {
            setSelectedCity(typeof userData.city === 'object'
                ? userData.city.id
                : userData.city);
        }
    }, [userData]);
    // Формируем параметры с учётом поиска и фильтра по типу ресторана
    var queryParams = __assign(__assign(__assign({ page: currentPage, limit: itemsPerPage, search: search }, (selectedType ? { type: selectedType } : {})), (selectedCity
        ? { cityId: Number(selectedCity) }
        : (userData === null || userData === void 0 ? void 0 : userData.city)
            ? { cityId: Number((_b = userData === null || userData === void 0 ? void 0 : userData.city) === null || _b === void 0 ? void 0 : _b.id) }
            : {})), ((isSuperAdmin || (userData === null || userData === void 0 ? void 0 : userData.isMiniAdmin)) && !establishmentScope.managedRestIds && !establishmentScope.userRestId
        ? {}
        : establishmentScope));
    var _j = useGetRestaurantsWithSearchQuery(queryParams, { skip: !user }), restaurantsData = _j.data, isRestaurantsLoading = _j.isLoading, refetch = _j.refetch;
    useEffect(function () {
        if (user) {
            refetch();
        }
    }, [currentPage, search, selectedType, selectedCity]);
    var _k = useDeleteRestaurantsMutation(), deleteRest = _k[0], isLoading = _k[1].isLoading;
    var navigate = useNavigate();
    var goToCreateRestaurant = function () {
        navigate('/establishments/create');
    };
    var goToCreateRestaurantUpdate = function (item) {
        navigate("/establishments/update?restId=".concat(item.id));
    };
    var debouncedSetSearchText = useDebounce(function (text) {
        setSearch(text);
        setCurrentPage(1);
    }, 300);
    // При выборе типа сбрасываем страницу и ставим выбранный тип
    var handleTypeChange = function (e) {
        console.log(selectedType, 'selectedTypeselectedTypeselectedType');
        setSelectedType(e.target.value);
        setCurrentPage(1);
    };
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                deleteRest({ restaurantsId: id });
                return [2 /*return*/];
            });
        });
    };
    var handlePreviousPage = function () {
        if (currentPage > 1) {
            setCurrentPage(function (prevPage) { return prevPage - 1; });
        }
    };
    var handleNextPage = function () {
        if (currentPage * itemsPerPage < ((restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.total) || 0)) {
            setCurrentPage(function (prevPage) { return prevPage + 1; });
        }
    };
    return (_jsxs("div", __assign({ className: 'EstablishmentsControlPage' }, { children: [_jsx(PageHeader, { children: _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '24px' } }, { children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u043C\u0438" })) }), _jsxs("div", __assign({ style: { padding: '40px' } }, { children: [(!isEmployee || !isManager) && _jsx(InputSearch, { setSearch: debouncedSetSearchText }), _jsxs("div", __assign({ style: {
                            display: 'flex',
                            gap: '16px',
                            marginTop: '16px',
                            marginBottom: '24px',
                        } }, { children: [_jsxs("select", __assign({ value: selectedType, onChange: handleTypeChange, className: "selectType" }, { children: [_jsx("option", __assign({ value: "" }, { children: "\u0412\u0441\u0435 \u0442\u0438\u043F\u044B" })), restaurantTypes.map(function (type) { return (_jsx("option", __assign({ value: type }, { children: type }), type)); })] })), (currentUserRole === "системный администратор" || (userData === null || userData === void 0 ? void 0 : userData.isMiniAdmin) === true) ? (_jsx("div", __assign({ style: { display: 'flex', gap: '10px', alignItems: 'center' } }, { children: _jsx(Select, { showSearch: true, style: { width: '200px' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434", value: selectedCity || undefined, disabled: !!(userData === null || userData === void 0 ? void 0 : userData.city), onChange: function (value) {
                                        if (userData === null || userData === void 0 ? void 0 : userData.city)
                                            return; // 🛡 доп. защита
                                        setSelectedCity(value);
                                        setCurrentPage(1);
                                    }, optionFilterProp: "children", filterOption: function (input, option) {
                                        var _a;
                                        return ((_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(input.toLowerCase())) ||
                                            false;
                                    }, options: __spreadArray(__spreadArray([], (!(userData === null || userData === void 0 ? void 0 : userData.city) ? [{ value: '', label: 'Все города' }] : []), true), ((cities === null || cities === void 0 ? void 0 : cities.map(function (city) {
                                        return ({
                                            value: city.id,
                                            label: city.name
                                        });
                                    })) || []), true) }) }))) : null] })), (!isEmployee) && (_jsx(AddIcon, { onClick: goToCreateRestaurant, style: { marginTop: '32px', marginBottom: '24px', cursor: 'pointer' } })), isRestaurantsLoading ? (_jsx(LoaderContainer, { children: _jsx(Loader, { width: '50px', height: '50px' }) })) : (_jsx("div", __assign({ style: { marginTop: '20px' } }, { children: ((_c = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _c === void 0 ? void 0 : _c.length) ? (__spreadArray([], restaurantsData.data, true).sort(function (a, b) { return a.id - b.id; })
                            .map(function (item, index) { return (_jsx(RestaurantItem, { onClick: function () { return goToCreateRestaurantUpdate(item); }, restaurant: item, onDelete: function () { return handleDelete(item.id); }, isFirst: index === 0, isLoading: isLoading, isLast: index === restaurantsData.data.length - 1 }, item.id)); })) : (_jsxs(TabletsList, { children: [_jsx(EmptyList, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 400, fontSize: '16px' } }, { children: "\u0417\u0434\u0435\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A\u00A0\u043F\u043B\u0430\u043D\u0448\u0435\u0442\u043E\u0432" }))] })) }))), currentUserRole !== 'сотрудник' && (_jsxs(PaginationContainer, { children: [_jsx(ChangePageButton, __assign({ onClick: handlePreviousPage, disabled: currentPage === 1 }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) })), _jsxs("span", { children: ["\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ", currentPage] }), _jsx(ChangePageButton, __assign({ onClick: handleNextPage, disabled: currentPage * itemsPerPage >= ((restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.total) || 0) }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) }))] }))] }))] })));
};
var PageHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #fff;\n  width: 100%;\n  padding-top: 43px;\n  padding-left: 40px;\n  padding-bottom: 27px;\n\n  @media (max-width: 800px) {\n    height: 150px;\n    padding-top: 90px;\n  }\n"], ["\n  background: #fff;\n  width: 100%;\n  padding-top: 43px;\n  padding-left: 40px;\n  padding-bottom: 27px;\n\n  @media (max-width: 800px) {\n    height: 150px;\n    padding-top: 90px;\n  }\n"])));
var TabletsList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var EmptyList = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  text-align: center;\n  margin: 20px 0;\n"], ["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  text-align: center;\n  margin: 20px 0;\n"])));
var LoaderContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"])));
var PaginationContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"])));
var ChangePageButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"])));
export default EstablishmentsControlPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
